import styled from 'styled-components/macro';
import { applyStyleModifiers } from 'styled-components-modifiers';

const TEXT_MODIFIERS = {
  inline: () => `
    display: inline;
  `,
  bold: ({ theme }) => `
    font-weight: ${theme.weight.bold};
  `,
  base: ({ theme }) => `
    font-weight: ${theme.weight.xbase};
  `,
  small: ({ theme }) => `
    font-size: ${theme.sizes.s};
  `,
  xs: ({ theme }) => `
    font-size: ${theme.sizes.xs};
  `,
  s: ({ theme }) => `
    font-size: ${theme.sizes.s};
  `,
  xl2: ({ theme }) => `
    font-size: ${theme.sizes.xl2};
  `,
  light: ({ theme }) => `
    color: ${theme.colors.baseLighter};
  `,
  lighter: ({ theme }) => `
    color: ${theme.colors.baseLighterS};
  `,
  weightBase: ({ theme }) => `
    font-weight: ${theme.weight.xbase};
  `,
  m: ({ theme }) => `
    font-size: ${theme.sizes.m};
  `,
  l: ({ theme }) => `
    font-size: ${theme.sizes.l};
  `,
  inverse: ({ theme }) => `
    color: ${theme.colors.baseInverse};
  `,
  content: ({ theme }) => `
    line-height: ${theme.spacing.l};
  `,
  danger: ({ theme }) => `
    color: ${theme.colors.danger};
  `,
  tooltip: () => `
    max-width: 200px;
  `,
  uppercase: () => `
    text-transform: uppercase;
  `,
  underline: () => `
    text-decoration: underline;
  `
};

const Text = styled.p`
  font-size: ${props => props.theme.sizes.s};
  color: ${props => props.theme.components.text.color};
  font-weight: ${props => props.theme.weight.light};
  line-height: ${props => props.theme.sizes.l};
  ${applyStyleModifiers(TEXT_MODIFIERS)};
`;

export default Text;
